// loaderService.js
let count = 0;
const subscribers = new Set();

function notify() {
  const isLoading = count > 0;
  subscribers.forEach((cb) => {
    try { cb(isLoading); } catch (e) { /* ignore subscriber errors */ }
  });
}

export const loaderService = {
  // increment loader counter and notify
  show() {
    count += 1;
    notify();
  },

  // decrement counter (never below 0) and notify
  hide() {
    count = Math.max(0, count - 1);
    notify();
  },

  // reset loader
  reset() {
    count = 0;
    notify();
  },

  // subscribe callback(isLoading) -> returns unsubscribe fn
  subscribe(cb) {
    subscribers.add(cb);
    // immediately call with current state
    try { cb(count > 0); } catch (e) {}
    return () => {
      subscribers.delete(cb);
    };
  },

  // useful for debugging
  _getCount() { return count; }
};
